if (!customElements.get('main-collection')) {
  customElements.define(
    'main-collection',
    class ProductCarousel extends HTMLElement {
      constructor() {
        super();
        this.sidebarToogle = this.querySelector('.facets-toggle-btn');
        this.sidebar = this.querySelector('aside');
        this.productGrid = this.querySelector('#product-grid');
        this.filterSlider = this.querySelector(
          'aside.facets-wrapper.horizontal .filter-slider',
        );
        this.filterSwiper = null;
        this.isSwiperActive = false;
      }

      connectedCallback() {
        this.showSidebar = false;
        if (localStorage.getItem('sidebarActive') === null) {
          localStorage.setItem('sidebarActive', 'false');
        }

        const sidebarState = localStorage.getItem('sidebarActive') === 'true';
        if (this.sidebarToogle) {
          this.setSidebarState(sidebarState);
        } else {
          localStorage.setItem('sidebarActive', 'false');
        }

        if (this.sidebarToogle) {
          this.sidebarToogle.addEventListener('click', () =>
            this.toggleSidebar(),
          );
        }

        this.stickyHorizontalFilters();
      }

      toggleSidebar() {
        const isActive = this.sidebar.classList.toggle('active');
        localStorage.setItem('sidebarActive', isActive);
        this.toggleIcons();
        this.toggleGridColumns();
      }

      setSidebarState(isActive) {
        if (isActive) {
          this.sidebar.classList.add('active');
        } else {
          this.sidebar.classList.remove('active');
        }
        this.toggleIcons(isActive);
        this.toggleGridColumns(isActive);
      }

      toggleIcons(forceState = null) {
        const isActive =
          forceState !== null
            ? forceState
            : this.sidebar.classList.contains('active');

        this.sidebarToogle
          .querySelector('.open-icon')
          .classList.toggle('hidden', isActive);
        this.sidebarToogle
          .querySelector('.close-icon')
          .classList.toggle('hidden', !isActive);
      }

      toggleGridColumns(forceState = null) {
        const isActive =
          forceState !== null
            ? forceState
            : this.sidebar.classList.contains('active');

        const gridColumn = parseInt(
          this.productGrid.getAttribute('data-desktop-columns'),
        );
        const defaultClass = `lg:leo-grid-cols-${gridColumn}`;
        const reducedClass = `lg:leo-grid-cols-${gridColumn - 1}`;

        const urlParams = new URLSearchParams(window.location.search);
        const layout = urlParams.get('grid-layout');

        if (layout != 'single-column') {
          if (isActive) {
            this.productGrid.classList.remove(defaultClass);
            this.productGrid.classList.add(reducedClass);
          } else {
            this.productGrid.classList.remove(reducedClass);
            this.productGrid.classList.add(defaultClass);
          }
        }
      }

      stickyHorizontalFilters() {
        const filterWrapper = this.querySelector(
          'aside.facets-wrapper.horizontal',
        );
        if (!filterWrapper) return;

        const swiperWrapper =
          this.filterSlider?.querySelector('.facets__wrapper');

        let isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

        const updateStickyState = () => {
          const rect = filterWrapper.getBoundingClientRect();

          const viewport = window.innerWidth;
          if (rect.top <= 0 && !this.isSwiperActive) {
            if (viewport > 1024) {
              filterWrapper.classList.add('sticky');
            }
            if (swiperWrapper) {
              swiperWrapper.classList.remove('mdl:leo-grid');
              swiperWrapper.classList.remove('mdl:leo-gap-x-5');
            }
            this.initFilterSwiper();
          } else if (rect.top > 50 && this.isSwiperActive) {
            if (viewport > 1024) {
              filterWrapper.classList.remove('sticky');
            }
            if (swiperWrapper) {
              swiperWrapper.classList.add('mdl:leo-grid');
              swiperWrapper.classList.add('mdl:leo-gap-x-5');
            }
            this.disableFilterSwiper();
          }
        };

        const handleScroll = () => {
          if (isIOS) {
            // Use requestAnimationFrame for iOS to prevent shaking
            requestAnimationFrame(updateStickyState);
          } else {
            updateStickyState();
          }
        };

        window.addEventListener('scroll', handleScroll, {passive: true});
      }

      initFilterSwiper() {
        if (this.isSwiperActive || !this.filterSlider) return;

        this.filterSwiper = new Swiper(this.filterSlider, {
          slidesPerView: 'auto',
          spaceBetween: 24,
          freeMode: true,
          freeModeMomentum: true,
          grabCursor: true,
          scrollbar: {
            el: '.facets-swiper-scrollbar',
            draggable: true,
          },
        });
        this.isSwiperActive = true;
      }

      disableFilterSwiper() {
        if (!this.isSwiperActive || !this.filterSwiper) return;
        this.filterSwiper.destroy(true, true);
        this.filterSwiper = null;
        this.isSwiperActive = false;
      }
    },
  );
}
